// import {Vue,VueRouter } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
// import home from '../components/HelloWorld.vue'
import home from '../views/HomeBook.vue'
import classic from '../views/ClassicBook.vue'
import welfare from '../views/WelfareBook.vue'
// 0. If using a module system (e.g. via vue-cli), import Vue and VueRouter
// and then call `Vue.use(VueRouter)`.

// 1. Define route components.
// These can be imported from other files
// const TestHome = { template: '<div>foo</div>' }
// const TestUser = { template: '<div>bar</div>' }

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  { path: '/', name: 'home', component: home },
  { path: '/classic', name: 'classic', component: classic },
  { path: '/welfare', name: 'welfare', component: welfare },
  { path: '/member/:section?', name: 'member', component: () => import('../views/MemberPortal.vue') },
  { path: '/pay', name: 'wallet-payment', component: () => import('../views/WalletCheckout.vue'), meta: { title: '订单付款' } },
  { path: '/about', name: 'about', component: () => import('../views/AboutSite.vue'), meta: { title: '关于本站' } },
  { path: '/privacy', name: 'privacy', component: () => import('../views/PrivacyPolicy.vue'), meta: { title: '隐私政策' } },
  { path: '/terms', name: 'terms', component: () => import('../views/TermsOfService.vue'), meta: { title: '服务条款' } }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
// const router = new VueRouter({
//   routes // short for `routes: routes`
// })
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.name !== from.name) return { top: 0 }
  }
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · 神乐老师网站` : '神乐老师网站'
})

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
// const app = new Vue({
//   router
// }).$mount('#app')

// // Now the app has started!

// export default app;

export default router